import { buildChatbotFilterChips } from '../utils/buildChatbotFilterChips';
import type { ChatbotActiveFilters, ChatbotMessageFilter, ChatbotSessionRequest } from '@/models/chatbot';

export interface SendChatbotVariables {
  request: ChatbotSessionRequest;
  promptFilters: ReadonlyArray<ChatbotMessageFilter>;
  isNewUserMessage: boolean;
}

type TranslateFn = (key: string) => string;

const EMPTY_ACTIVE_FILTERS: ChatbotActiveFilters = {};
export const NEW_CONVERSATION_ID = 'new';

export function sanitizeActiveFilters(
  activeFilters: ChatbotSessionRequest['active_filters'],
): ChatbotSessionRequest['active_filters'] {
  const sanitizedActiveFilters: ChatbotActiveFilters = {};

  const globalFilters = activeFilters?.globalFilters;
  if (globalFilters && Object.keys(globalFilters).length > 0) {
    sanitizedActiveFilters.globalFilters = { ...globalFilters };
  }

  const localFilters = activeFilters?.localFilters;
  if (localFilters && Object.keys(localFilters).length > 0) {
    sanitizedActiveFilters.localFilters = { ...localFilters };
  }

  const resolvedCountryCodes = activeFilters?.resolvedCountryCodes;
  if (resolvedCountryCodes && resolvedCountryCodes.length > 0) {
    sanitizedActiveFilters.resolvedCountryCodes = [...resolvedCountryCodes];
  }

  return Object.keys(sanitizedActiveFilters).length > 0 ? sanitizedActiveFilters : undefined;
}

export function buildSendChatbotVariables(
  message: string,
  conversationId: string | null,
  activeFilters: ChatbotSessionRequest['active_filters'],
  t: TranslateFn,
): Pick<SendChatbotVariables, 'request' | 'promptFilters'> {
  const sanitizedActiveFilters = sanitizeActiveFilters(activeFilters);

  return {
    request: {
      message,
      conversation_id: conversationId ?? NEW_CONVERSATION_ID,
      page_url: typeof window === 'undefined' ? '' : window.location.pathname,
      ...(sanitizedActiveFilters ? { active_filters: sanitizedActiveFilters } : {}),
    },
    promptFilters: buildChatbotFilterChips(sanitizedActiveFilters ?? EMPTY_ACTIVE_FILTERS, t),
  };
}
